import { FC, useState } from 'react'
import { Link } from 'react-router-dom'

import './style.scss'
import CONFIG from '../../../config'
import menuData from '../../utils/menu'
import menuAdminData from '../../utils/menuAdmin'
import menuSuperAdminData from '../../utils/menu-super-admin'
import { AuthRoles } from '../../models'
import { Icon } from '../../components/UI'
import { useSelector } from 'react-redux'

type MenuProps = {
  className?: string,
  role?: AuthRoles,
  mobileOnlyShow?: true,
  onClose?:() => void
}

const Menu:FC<MenuProps> = ({ className = '', role = '', mobileOnlyShow = false, onClose })  => {
  const [index, setIndex] = useState<number>(0)

  // Usar rol del usuario para elegir menu, y usar props.role en caso de que no se pueda obtener del redux state
  const userRole = useSelector((state: any) => state?.userCurrentStorage?.info?.rol)
  let userRoleToDisplayMenu = userRole ? userRole : role;
  if (role == CONFIG.AUTH.ROLES.STANDART || role == '') {
    userRoleToDisplayMenu = role;
  }

  const onMenuSubClick = ((id: number, event: any) => {
    event.preventDefault()
    setIndex(id === index ? 0 : id)
  })

  const onMenuClose = () => {
    if(onClose) onClose()
  }

  return (
    <ul id="menu_portal" className={`menu ${mobileOnlyShow ? 'menu--mobile-show' : ''} ${className}`}>
      {userRoleToDisplayMenu === CONFIG.AUTH.ROLES.ADMIN ?
          <>
            {menuAdminData.map((it, i) =>
              <li key={it.id} id={"main_opt_"+it.id}>
                <Link to={it.url} onClick={onMenuClose} className={'option_link_main'} title={it.name}>
                  <Icon name={it.icon} color="gray" />{it.name}
                </Link>
              </li>
            )}
          </>
        :
          (userRoleToDisplayMenu === CONFIG.AUTH.ROLES.SUPERADMIN ? 
            <>
              {menuSuperAdminData.map((it, i) =>
                <li key={it.id} id={"main_opt_"+it.id}>
                  <Link to={it.url} onClick={onMenuClose} className={'option_link_main'} title={it.name}>
                    <Icon name={it.icon} color="gray" />{it.name}
                  </Link>
                </li>
              )}
            </>
           : 
           <>
              {menuData.map((it, i) =>
                <li key={it.id} id={"main_opt_"+it.id} className={"option_main"}>
                  {it.children && it.children.length ?
                      <a href="# " className={index === it.id ? 'menu_sub--active option_link_main' : 'option_link_main' } onClick={(event) => onMenuSubClick(it.id, event)} title={it.name}>
                        <Icon name={it.icon} color="gray" />{it.name}
                        <Icon name="menu-arrow-down" className="ml-10" />
                      </a>
                    :
                      <Link to={it.url} onClick={onMenuClose} className={'option_link_main'} title={it.name}>
                        <Icon name={it.icon} color="gray" />{it.name}
                      </Link>
                  }
                  {it.children && index === it.id &&
                    <ul className="menu_sub">
                      {it.children.map((it2, j) =>
                        <li key={j}>
                          <Link to={it2.url} onClick={onMenuClose} className={'option_link_main'} title={it.name}>{it2.name}</Link>
                        </li>
                      )}
                    </ul>
                  }
                </li>
              )}
            </>
          )
      }
    </ul>
  )
}

export { Menu }